import type { CSSProperties, FC, ReactNode } from 'react';
import { useHeaderHeight } from 'src/hooks/use-header-height';

export const Sticky: FC<{ children: ReactNode }> = ({ children }) => {
  const { height } = useHeaderHeight();
  const padding = 20;
  const top = height + padding;
  return (
    <div className="h-full">
      <div
        style={{ '--sticky-top': `${top}px` } as CSSProperties}
        className="sticky top-(--sticky-top)"
      >
        {children}
      </div>
    </div>
  );
};
